import { Box } from "@mui/material";

import { DataGrid } from "components/DataGrid";
import { format } from "date-fns";
import { formatToNaira } from "utils/formatCurrency";

const columns = [
  { field: "bankName", headerName: "BANK NAME", flex: 1 },
  { field: "accountNumber", headerName: "ACCOUNT NUMBER", flex: 1 },
  {
    field: "balance",
    headerName: "BALANCE",
    flex: 1,
    valueFormatter: ({ value }) => formatToNaira(value), 
  },
  {
    field: "lastUpdated",
    headerName: "LAST UPDATED",
    flex: 1,
    valueFormatter: ({ value }) => {
      if (!value) return "—";
      const date = new Date(value);
      return format(date, "dd/MM/yyyy hh:mm a");
    },
  },
];


export const BalanceSummaryTable= ({balances}) => {

  return (
    <Box>
      <DataGrid
        rows={balances || []}
        columns={columns}
        disableColumnMenu
        disableRowSelectionOnClick
    
      />
    </Box>
  );
};
